import Service from '../../services'
import Swal from "sweetalert2";

// initial state
const state = {
    jobsGroupForm: {
        name_th: '',
        name_en: ''
    },

    allJobsGroupPaginate: {}

};


// getters
const getters = {

};


// actions
const actions = {

    onGetAllJobsGroupPaginate({ commit }, data) {
        return Service.job.getAllJobsGroupPaginate(data).then((res) => {
            commit('setAllJobsGroupPaginate', res);
        });
    },

    onGetJobsGroup({ commit }, data) {
        return Service.job.getJobsGroup(data).then((res) => {
            commit('setJobsGroup', res);
        });
    },

    onCreateJobsGroup({ commit }, data) {
        return Service.job.createJobsGroup(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditJobsGroup({ commit }, data) {
        return Service.job.editJobsGroup(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteJobsGroup({ commit }, data) {
        return Service.job.deleteJobsGroup(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    }

};


// mutations
const mutations = {

    setAllJobsGroupPaginate(state, data) {
        state.allJobsGroupPaginate = data;
    },

    setJobsGroup(state, data) {
        state.jobsGroupForm = {
            name_th: data.name_th,
            name_en: data.name_en
        };
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
